import { TYPE_DATE_COMPARISON } from './input-types';

export const id = 'returnReceived';
export const apiKey = 'returnReceived';
export const type = TYPE_DATE_COMPARISON;

export const returnReceived = {
  id,
  apiKey,
  type,
};
